import { Directive, App, nextTick } from 'vue';

const autoComplateOffDirective: Directive = {
  mounted(el) {
    nextTick(() => {
      el.setAttribute('autocomplete', 'off');
    });
  },
};

export function setupAutoComplateOffDirective(app: App) {
  app.directive('autoComplateOff', autoComplateOffDirective);
}

export default autoComplateOffDirective;
